@let t = theme();
@let seconds = sessionTimer.secondsForUi();
<div
  class="idh-top-bar__container"
  [class.toast-offset]="isMobileDevice && t.timerType === TimerTypeEnum.toast"
  [class.toast-visible]="toastVisible()"
>
    @if (logo(); as logoVariant) {
      <img class="logo"
           [ngClass]="logoVariant.logoClass"
           [src]="logoVariant.src"
           [width]="logoVariant.width"
           [height]="logoVariant.height"
           alt="Logo"
      />
    }

  <div class="idh-top-bar__side">
    @if ((t.timerType === TimerTypeEnum.nav) && toastVisible()) {
      <idh-timer [seconds]="seconds"/>
    }
    @if (t.barInfoKey) {
      <idh-top-bar-info [key]="t.barInfoKey"> </idh-top-bar-info>
    }
    <idh-language />
  </div>
</div>
